import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers } from 'recompose'

import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'

export default compose(
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.user) || null,
        hasError: idx(state, _ => _.progress.createAccount.hasError) || false,
        errorMessage: idx(state, _ => _.progress.createAccount.error.message) || null,
      }
    },
    (dispatch) => {
      const actions = {
        ...routeActions,
        ...userActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    onCreateSubmit: props => (createFields) => {
      props.actions.createUser(createFields, () => {
        props.actions.loginUser(createFields)
      })
    },
  }),
)



// WEBPACK FOOTER //
// ./src/containers/account/CreateAccount/CreateAccount.enhancer.js